import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Icon from 'view/Icon';
import Popover from 'components/UI/Popover';
import { Size } from 'lib/styles';
import { IssueSelectorError } from 'data/Generic';
import IssueSelectorOption from './IssueSelectorOption';

const Container = styled.div<any>`
  margin-right: ${Size.large};
  max-width: 20rem;
  outline: none;
  position: relative;
  user-select: none;
  z-index: 100000;

  ${props => !props.visible && css`
    visibility: hidden;
  `}
`;

const Description = styled.div`
  font-size: 14px;
`;

const Heading = styled.div`
  align-items: center;
  display: flex;
  font-size: 20px;
  font-weight: bold;
`;

const HeadingIcon = styled(Icon).attrs({ name: 'CaretDropdown', size: 10 })`
  margin-left: ${Size.medium};
  margin-top: ${Size.tiny};
`;

const HeadingText = styled.div``;

const Selected = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
`;

const StyledPopover = styled<any>(Popover)`
  position: absolute;
  min-width: 100%;
  width: auto;
  z-index: 1000;
`;

interface Props {
    className?: string;
    errors: IssueSelectorError[];
    onSelect: () => void;
    visible?: boolean;
    getErrorText: (error: IssueSelectorError) => any;
    highlightErrors?: boolean;
};

const IssuesSelector = ({
    className,
    errors,
    onSelect,
    visible = true,
    getErrorText,
    highlightErrors = false
}: Props) => {
    const [open, setOpen] = useState(false);

    let selectedText = {
        name: `${errors.length} issue${errors.length > 1 ? 's' : ''}`,
        description: highlightErrors ? 'Clear' : 'Show All'
    };

    const selected = (
        <Selected>
            <Heading onClick={() => setOpen(!open)}>
                <HeadingText className='variant-issue-selector-heading-text'>{selectedText.name}</HeadingText>
                <HeadingIcon className='heading-icon-black' />
            </Heading>
            <Description
                onClick={onSelect}
                className='variant-issue-selector-description'
            >
                {selectedText.description}
            </Description>
        </Selected>
    );

    let popover = null;

    if (open) {
        const formattedErrors = errors.map((index) => { return getErrorText(index) });
        popover = (
            <StyledPopover
                maxHeight={500}
                options={formattedErrors}
                renderOption={(error: typeof formattedErrors[0]) => (
                    <IssueSelectorOption error={error} />
                )}
            />
        );
    }

    return (
        <Container
            className={className}
            onBlur={() => setOpen(false)}
            tabIndex={0}
            visible={visible}
        >
            {selected}
            {popover}
        </Container >
    );
};

export default IssuesSelector;